import type { CurationRun } from './types';

export type RunErrorMessage =
  | { key: string; values: Record<string, number | null> }
  | { text: string };

// How a run's stored error reads on the page. A held run gets a translated
// explanation with its numbers; anything else is shown as stored.
export function runErrorMessage(
  run: Pick<CurationRun, 'error' | 'budget_units' | 'estimated_units'>,
): RunErrorMessage | null {
  if (!run.error) return null;
  if (run.error === 'budget_below_estimate') {
    return {
      key: 'admin.communityCuration.runs.heldBudget',
      values: { budget: run.budget_units, estimated: run.estimated_units },
    };
  }
  return { text: run.error };
}
